/* eslint-disable react/destructuring-assignment */
/* eslint-disable semi */
/* eslint-disable max-len */
/* eslint-disable max-classes-per-file */
import React from 'react'
import { FormItem, FormItemProps } from './FormItem'
import { IField, getRequiredError } from './FieldValidation'
import { Option } from './Options'
import { YesNoPrefer } from '../Utility'

export const yesNoDataSource = [{ value: true, label: 'Yes' }, { value: false, label: 'No' }];
export const yesNoDataSourceInverted = [{ value: false, label: 'Yes' }, { value: true, label: 'No' }];
export const yesNoPreferNotSayDataSource = [{ value: 1, label: 'Yes' }, { value: 0, label: 'No' }, { value: 2, label: 'Prefer not to answer' }];
export const yesNoNADataSource = [{ value: 1, label: 'Yes' }, { value: 0, label: 'No' }, { value: 2, label: 'Not Applicable' }];
export const yesNoPreferNotSayDataSourceEx = [{ value: YesNoPrefer.Yes, label: 'Yes' }, { value: YesNoPrefer.No, label: 'No' }, { value: YesNoPrefer.PreferNotToAnswer, label: 'Prefer not to answer' }];

// eslint-disable-next-line no-shadow
export enum LayoutDisplayEnum {
    Horizontal = 'horizontal',
    Vertical = 'vertical'
}

export interface RadioButtonFieldProps<V> extends FormItemProps {
    id: string
    block?: boolean
    onChange: { (value: V): any },
    value: V,
    dataSource: Option<V>[],
    required?: boolean
    requiredMessage?: string
    disabled?: boolean
    layout?: LayoutDisplayEnum
}

export interface RadioButtonFieldState {
    errorText?: string
}

export class RadioButtonField<V> extends React.Component<RadioButtonFieldProps<V>, RadioButtonFieldState> implements IField {
  inputs: { [value:string]:HTMLInputElement }

  constructor(props?: RadioButtonFieldProps<V>, context?: any) {
    super(props, context);

    this.inputs = {};

    this.state = {};
  }

  componentDidUpdate(prevProps: RadioButtonFieldProps<V>, prevState: RadioButtonFieldState) {
    if (this.props.value != prevProps.value) {
      if (this.state.errorText) {
        this.validate(() => { });
      }
    }
  }

  onChange(value: string) {
    if (this.props.dataSource) {
      for (let data of this.props.dataSource) {
        if ((data.value as any).toString() == value) {
          this.props.onChange(data.value);
          break;
        }
      }
    }
  }

  render() {
    const layoutClass = this.props.layout === LayoutDisplayEnum.Vertical ? 'emdg-control-input--vertical' : '';

    if (this.props.preview) {
      return (
        <>
          <FormItem {...this.props} errorMessage={this.state.errorText}>
            {this.props.dataSource.filter(r => r.value == this.props.value).map((d, i) => (
              <div className="form-value" key={i}>{d.label}</div>
            ))}
          </FormItem>
          {this.props.description && (
            <FormItem
              label={(
                <span
                  className="form-content-preview"
                  style={{ fontSize: this.props.preview ? '10pt' : 'inherits' }}
                >
                  {this.props.description}
                </span>
              )}
            />
          )}
        </>
      )
    }

    let items: JSX.Element[] = [];
    if (this.props.dataSource) {
      items = this.props.dataSource.map((d, i) => {
        let inputId = this.props.id + "_" + i;
        return (
          <div
            key={i}
            className={
                `emdg-control-input ${layoutClass}`
                + `${this.props.block ? ' emdg-control-input--block' : ''}`
                + `${this.state.errorText ? ' emdg-control-input--invalid' : ''}`
                + `${this.props.className ? (` ${this.props.className}`) : ''}`
            }
          >
            <input
              ref={r => this.inputs[(d.value as any).toString()] = r}
              className="emdg-control-input__input"
              type="radio"
              id={inputId}
              name={this.props.id}
              value={(d.value as any).toString()}
              checked={d.value == this.props.value}
              onChange={e => this.onChange((e.target as HTMLInputElement).value)}
              disabled={this.props.disabled}
            />
            <label className="emdg-control-input__text mb-0" htmlFor={inputId}>{d.label}</label>
          </div>
        )
      });
    }

    return (
      <FormItem {...this.props} inputId={this.props.id} errorMessage={this.state.errorText}>
        <div>
          {items}
        </div>
      </FormItem>
    )
  }

  focus() {
    let key = this.props.value ? (this.props.value as any).toString() : null;
    if (key in this.inputs) {
      if (this.inputs[key]) {
        this.inputs[key].focus();
        return;
      }
    }

    key = (this.props.dataSource[0].value as any).toString();
    if (key in this.inputs) {
      if (this.inputs[key]) {
        this.inputs[key].focus();
        return;
      }
    }
  }

  hasValue(): boolean {
    let res = false;
    if (this.props.dataSource) {
      for (let data of this.props.dataSource) {
        if (data.value == this.props.value) {
          res = true;
          break;
        }
      }
    }
    return res;
  }

  getErrorText(): string {
    if (this.props.required === true) {
      if (!this.hasValue()) {
        return getRequiredError(this.props);;
      }
    }
    return null;
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    let errorTest = this.getErrorText();
    this.setError(errorTest, () => {
      if (errorTest) {
        if (focus === true) {
          this.focus();
        }
      }
      callback && callback(errorTest ? false : true);
    })
  }

  setError(errorText?: string, callback?: { (): any }) {
    this.setState({ errorText }, callback);
  }
}

export class TextRadioButtonField extends RadioButtonField<string> { }

export class NumericRadioButtonField extends RadioButtonField<number> { }

export class BooleanRadioButtonField extends RadioButtonField<boolean> { }
